import '../src/style/index.scss';
import getOperatorCustomRoutes from '../src/routes/routes';
import createApp from '@om-fe/core/client/client';
import { CustomAppProps } from '@om-fe/core/app/app';
import { logError } from '@om-fe/core/utils/trackjs';

const customAppProps: CustomAppProps = {
    getRoutes: getOperatorCustomRoutes,
};

createApp(customAppProps)
    .catch(logError);
